// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState } from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
  margin-top: 10px;
  margin-bottom: 40px;
  margin-left: -19px;
`;
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
export default ({ content }) => {
  const [currentBudget, changeBudget] = useState('per party');
  let sum = 0;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  const events = content.filter(event => event.costType === currentBudget);
  if (events.length !== 0) {
    sum = events.reduce((acc, event) => acc + Number.parseFloat(event.cost), 0);
  }
  const personActive = currentBudget === 'per person' ? 'budget-active' : '';
  const partyActive = currentBudget === 'per party' ? 'budget-active' : '';
  return (
    <StyledContainer>
      <div
        className='budget'
        style={{
          display: 'inline-block',
          fontSize: '22px',
          fontWeight: 'bold',
          textAlign: 'center',
        }}
      >
        <i className='fas fa-dollar-sign' />
        {sum}
        <div
          style={{
            width: '160px',
            fontSize: '14px',
            marginTop: '-6px',
            fontWeight: 'normal',
          }}
        >
          Total Itinerary Cost
        </div>
      </div>
      <div
        className={`budget-button budget-left ${personActive}`}
        onClick={() => changeBudget('per person')}
      >
        per person
      </div>
      <div
        className={`budget-button budget-right ${partyActive}`}
        onClick={() => changeBudget('per party')}
      >
        per party
      </div>
    </StyledContainer>
  );
};
